import * as React from 'react';

import {Body} from 'shells/typography/body';

import styles from './cycle-control.module.css';

type CycleControlProps = {
    title: string;
    subtitle?: string;
    height?: number;
};

export function CycleControl(props: CycleControlProps) {
    return (
        <div style={{height: props.height}} className={styles['cycle-control']}>
            <Body isBold={true}>{props.title}</Body>
            {props.subtitle && (
                <Body size='mini' color='green'>
                    {props.subtitle}
                </Body>
            )}
        </div>
    );
}
